module.exports = __webpack_public_path__ + "static/media/SE-LOGO-FINAL.05a76927.png";